import { Deserializable } from './deserializable.model';

/* export interface Tipo {
    id_proced?: number;
    nomeTipo: string;
} */

export class Procedimento implements Deserializable {
  public _id?: number;
  public nomeProced?: string;
  public tipo?: string;
  public createdAt: Date;
  public updatedAt: Date;

  deserialize(input: any): this {
    return Object.assign(this, input);
  }
}